
export enum TimeRange {
  All = 'all',
  Year = '12M',
  Quarter = '3M',
  Month = '1M'
}
